import { FC } from "react";

export const Advert: FC = () => {
  return (
    <section className="container">
      <h1>Ads on the map</h1>
    </section>
  )
}